import React, { useEffect, useState } from 'react'
import { Avatar, Box, Stack, Wrap, WrapItem, Text, HStack, Button, Center } from '@chakra-ui/react'
import { useDialerCallStatus, useDialerState } from '../dialer/dialer.hooks'
import { truncateWithEllipsis } from 'utils/string-formatters'
import { BsTelephoneFill } from 'react-icons/bs'
import { useIncomingCall } from './hooks'
import { Call } from '@twilio/voice-sdk'
import { useAllResidents, useCallDurationLabel, useContactCenterModalEvents, useTwilioCallConnection } from '../contact-center.hooks'
import { createPortal } from 'react-dom'
import { maskPhoneNumber } from '../contact-center.utils'
import { useQueryClient } from 'react-query'
import _ from 'lodash'

type IncomingCallProps = {}

export const IncomingCall: React.FC<IncomingCallProps> = () => {
  const [isIncoming, setIsIncoming] = useState(false)
  const { setDialerState } = useDialerState()
  const { connection } = useTwilioCallConnection()
  const { set: setCallStatus } = useDialerCallStatus()
  const { setLabel: setDurationLabel } = useCallDurationLabel()
  const { open: openContactCener } = useContactCenterModalEvents()
  const { data: residents } = useAllResidents()
  
  let timeInterval: any = undefined
  const queryClient = useQueryClient();

  const onDisconnect = () => {
    setDialerState(prev => ({ ...prev, isOpen: false, isCalling: false }))
    clearInterval(timeInterval)
  }
  const onCancel = () => {
    setIsIncoming(false);
  }

  const onIncoming = () => {
    setIsIncoming(true)
    queryClient.invalidateQueries(["call-logs"]);
  }

  useIncomingCall({ onIncoming, onDisconnect, onCancel })

  const handleReject = () => {
    setIsIncoming(false)
    console.log('🚀 ~ file: IncomingCall.tsx:22 ~ connection:', connection)
    connection?.reject()
  }

  const handleAccept = () => {
    setIsIncoming(false)
    connection?.accept()

    setDialerState(prev => ({ ...prev, isOpen: false, isCalling: true }))

    setCallStatus(prev => ({ ...prev, currentLabel: 'In-progress' }))

    openContactCener()

    const startTime = Math.floor(Date.now() / 1000)

    timeInterval = setInterval(() => {
      const elapsedTime = Math.floor(Date.now() / 1000) - startTime
      const minutes = Math.floor(elapsedTime / 60)
      const seconds = elapsedTime % 60
      const formattedTime = minutes + ':' + (seconds < 10 ? '0' : '') + seconds

      if (connection?.status() === Call.State.Open) {
        setDurationLabel(formattedTime)
      }
    }, 1000)
  }

  useEffect(() => {
    if (!isIncoming) return
  }, [isIncoming])


  let contact = {
    firstName: 'Unknown',
    lastName: 'Caller',
    phoneNumber: maskPhoneNumber(connection?.parameters?.From || ''),
  }

  if ( isIncoming ) {
    const contactRet = _.clone(
      residents?.find(
        (r: any) =>
          connection?.parameters?.From.replace(/\D/g, '').replace(/^1/, '') ===
          r.phoneNumber?.toString().replace(/\D/g, '').replace(/^1/, ''),
      ) as any,
    )
    if ( contactRet )
        contact = contactRet
  }
  return createPortal(
    <>
      {isIncoming && (
        <Box
          data-testid="incoming-call-box"
          bg="#fff"
          border="1px solid #E2E8F0"
          rounded="md"
          zIndex={2000}
          w="260px"
          position="fixed"
          left="80%"
          top="52px"
          boxShadow="0px 10px 10px -5px rgba(0, 0, 0, 0.04), 0px -10px 10px -5px rgba(0, 0, 0, 0.04), 0px 20px 25px -5px rgba(0, 0, 0, 0.10), 0px -20px 25px -5px rgba(0, 0, 0, 0.10)"
        >
          <Center>
            <Box py={5}>
              <Wrap cursor="pointer" onClick={() => {}}>
                <WrapItem>
                  <Avatar name={`${contact.firstName} ${contact.lastName}`} size="md" />
                </WrapItem>
                <WrapItem>
                  <Stack>
                    <Text fontSize="12px" color="gray.600" fontWeight="500" isTruncated={true}>
                      {truncateWithEllipsis(`${contact.firstName} ${contact.lastName}`, 30)}
                    </Text>
                    <Text fontSize="12px" fontWeight="400" color="gray.700">
                      {contact.phoneNumber}
                    </Text>
                  </Stack>
                </WrapItem>
              </Wrap>
            </Box>
          </Center>
          <Box>
            <HStack w="100%" spacing="0">
              <Box w="100%">
                <Button
                  width="100%"
                  backgroundColor="#E53E3E"
                  borderRadius="0 0 0px 6px"
                  sx={{
                    svg: {
                      transform: 'rotate(135deg) !important',
                    },
                  }}
                  leftIcon={<BsTelephoneFill fontSize="12px" />}
                  onClick={handleReject}
                >
                  Decline
                </Button>
              </Box>
              <Box w="100%">
                <Button
                  width="100%"
                  backgroundColor="#48BB78"
                  borderRadius="0 0 6px 0px"
                  leftIcon={<BsTelephoneFill fontSize="12px" />}
                  onClick={handleAccept}
                >
                  Accept
                </Button>
              </Box>
            </HStack>
          </Box>
        </Box>
      )}
    </>,
    document.body,
  )
}
